import {gsap} from "../LibrariesImport";

export default class BlockMarkets {

	static init() {
		document.querySelectorAll(".block-markets").forEach(block => {
			block.currentButton = block.querySelector(".markets a[data-market-index].active");
			block.animatedPart = block.querySelector(".animated-part");
			block.currentButton.image = block.querySelector(".media img[data-market-index].active");
			block.querySelectorAll(".markets a[data-market-index]").forEach(button => {
				button.image = block.querySelector(`.media img[data-market-index="${button.dataset.marketIndex}"]`);
				button.addEventListener("mouseenter", () => {
					if (window.innerWidth > 767) {
						block.currentButton.classList.remove("active");
						block.currentButton.image.classList.remove("active");
						button.classList.add("active");
						button.image.classList.add("active");
						block.currentButton = button;
						gsap.to(block.animatedPart, {
							opacity: 0,
							overwrite: true,
							duration: 0.2,
							onComplete: () => {
								block.animatedPart.style.backgroundImage = "url(" + button.dataset.partUrl + ")";
								gsap.to(block.animatedPart, {
									opacity: 1,
									overwrite: true,
									duration: 0.2
								});
							}
						});
					}
				});
			});
		});
	}
}
